import React, { FunctionComponent, memo } from 'react';
import { InputAdornment, IconButton, makeStyles, SearchIcon, CloseIcon, Input } from '@rbx/ui';

export const translationKeyInputPlaceholder = 'Label.SearchReference';
export const translationKeySearchIcon = 'Label.SearchIcon';
export const translationKeyClearSearchButton = 'Label.ClearSearchButton';

const useStyles = makeStyles()(() => ({
  filterField: {
    marginTop: '16px',
    marginBottom: '16px',
    width: '100%',
  },
}));

type SidebarFilterProps = {
  filterQuery: string;
  onFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClearFilter: () => void;
  inputRef: React.RefObject<HTMLInputElement>;
  translate: (key: string) => string;
};

const SidebarFilter: FunctionComponent<SidebarFilterProps> = ({
  filterQuery,
  onFilterChange,
  onClearFilter,
  inputRef,
  translate,
}) => {
  const {
    classes: { filterField },
  } = useStyles();

  return (
    <Input
      className={filterField}
      placeholder={translate(translationKeyInputPlaceholder) || 'Search reference'}
      title={translate(translationKeyInputPlaceholder) || 'Search reference'}
      value={filterQuery}
      onChange={onFilterChange}
      inputRef={inputRef}
      startAdornment={
        <InputAdornment position='start'>
          <SearchIcon aria-label={translate(translationKeySearchIcon) || 'Filter'} />
        </InputAdornment>
      }
      endAdornment={
        filterQuery && (
          <InputAdornment position='end'>
            <IconButton
              aria-label={translate(translationKeyClearSearchButton) || 'Clear Filter'}
              size='small'
              onClick={onClearFilter}>
              <CloseIcon color='secondary' fontSize='small' />
            </IconButton>
          </InputAdornment>
        )
      }
    />
  );
};

export default memo(SidebarFilter);
